// extracted by mini-css-extract-plugin
export default {"root":"_6GUMvMIy","info":"_6BdqGet4","link":"_5kUniDZF"};